import { AdminProvider } from './../../providers/admin/admin';
import { Observable } from 'rxjs/Observable';
import { User } from './../../models/User';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'admin-user-payments',
  templateUrl: 'admin-user-payments.html'
})
export class AdminUserPaymentsComponent {
  @Input('user') user: User;

  payments: Observable<any[]>;

  constructor(public admin: AdminProvider) {

  }

  ngOnInit(){
    this.payments = this.admin.getPayments(this.user.uid);
  }
}



// WEBPACK FOOTER //
// ./src/components/admin-user-payments/admin-user-payments.ts